// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__22gMc","top":"styles_top__JJlVG","left":"styles_left__3D31R","description":"styles_description__1wiSf"};